import OverlayTips from "../../OverlayTips";

function BalanceHistoryPageOverlayTipsManager()
{
    PageOverlayTipsManager.call(this);
    this._refreshDynamicTipsDeferred = true;
}

BalanceHistoryPageOverlayTipsManager.prototype = _.create(PageOverlayTipsManager.prototype, {

    addBaseTips: function()
    {
        PageOverlayTipsManager.prototype.addBaseTips.apply(this);

        this.add($("#balanceHistory_userSelector"), {
            messageKey: "actiplans.reports.balance_history.tips.user_selector",
            direction: OverlayTips.DIRECTION_TOP_LEFT,
            offsetX: -250,
            offsetY: -5
        });

        this.add($("#balanceHistory_typeSelector"), {
            messageKey: "actiplans.reports.balance_history.tips.balance_type_selector",
            direction: OverlayTips.DIRECTION_BOTTOM_RIGHT,
            offsetX: -120,
            offsetY: 11
        });

        this.add(function() {
            var $balanceHistoryPage = $("#balanceHistoryPage");
            if ($balanceHistoryPage.hasClass("sickControlOffWarn") || $balanceHistoryPage.hasClass("ptoControlOffWarn"))
            {
                return $();
            }
            return $("#balanceHistoryExportSelector");
        }, {
            messageKey: "actiplans.reports.tips.export",
            direction: OverlayTips.DIRECTION_TOP_LEFT,
            offsetX: -40,
            offsetY: 15
        });
    }
});

export default BalanceHistoryPageOverlayTipsManager;


// WEBPACK FOOTER //
// ./web/actiplans/js/tips/managers/reports/BalanceHistoryPageOverlayTipsManager.js